import { useEffect, useState } from 'react'

import { Layout } from '@loadsmart/loadsmart-ui'

import { SignUpDialog } from 'auth/ui/SignUpDialog'

import Logo from '../../assets/icon-loadsmart.svg'
import SignUpBannerBackground from '../../assets/signup-banner-bg.png'
import {
  BannerButton,
  Banner,
  StyledText,
  ImageBanner,
  StyledLayoutStack,
} from './SignUpBanner.styles'

export type SignUpBannerProps = {
  onView?: () => void
  onClick?: () => void
}

export function SignUpBanner({ onView, onClick }: SignUpBannerProps): JSX.Element {
  const [isSignUpOpen, setSignUpOpen] = useState(false)

  function handleOpenSignUp() {
    onClick?.()

    setSignUpOpen(true)
  }

  function handleCloseSignUp() {
    setSignUpOpen(false)
  }

  useEffect(() => {
    onView?.()
  }, [onView])

  return (
    <>
      {isSignUpOpen && (
        <SignUpDialog
          onCancel={handleCloseSignUp}
          onComplete={handleCloseSignUp}
          context="signup-banner"
        />
      )}
      <Banner>
        <Layout.Switcher>
          <StyledLayoutStack>
            <StyledText variant="heading-md-bold">
              Be part of a carrier platform with more freight opportunities
            </StyledText>
            <StyledText variant="body">
              Get notification from other shippers and brokers outside your network. See all your
              bid's status and be instantly notified when your bid is awarded or not.
            </StyledText>
            <BannerButton
              variant="primary"
              leading={<img src={Logo} alt="" />}
              onClick={handleOpenSignUp}
            >
              Join the carrier platform
            </BannerButton>
          </StyledLayoutStack>
          <ImageBanner src={SignUpBannerBackground} />
        </Layout.Switcher>
      </Banner>
    </>
  )
}
